export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_05.4904d584.jpg";